import { Switch, withStyles } from '@material-ui/core';
export const SwitchCus = withStyles({
  switchBase: {
    '&$checked': {
      color: '#f50057',
    },
    '&$checked + $track': {
      backgroundColor: '#f586ac',
    },
  },
  checked: {},
  track: {
    backgroundColor: '#b1acac',
  },
})(Switch);
